import transformGoogleAddress from './transform-google-address';
export default transformGoogleAddress;
